import { render, staticRenderFns } from "./IconoEntregado.vue?vue&type=template&id=1e860d4a&"
import script from "./IconoEntregado.vue?vue&type=script&lang=js&"
export * from "./IconoEntregado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports